<div class="layout">
  <router-outlet></router-outlet>
</div>